import NavBar from './NavBar'

export default function Layout({
  children,
  inboxCount,
}: {
  children: React.ReactNode
  inboxCount?: number
}) {
  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb', fontFamily: 'system-ui, sans-serif' }}>
      <NavBar inboxCount={inboxCount} />
      <main style={{ padding: '2rem', maxWidth: '1100px', margin: '0 auto' }}>
        {children}
      </main>
    </div>
  )
}
